import { render, staticRenderFns } from "./AltaPsp.vue?vue&type=template&id=8cd1b00e&scoped=true"
import script from "./AltaPsp.vue?vue&type=script&lang=js"
export * from "./AltaPsp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd1b00e",
  null
  
)

export default component.exports